import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormErrors from "../formErrors";
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { List as LINQ } from "linqts";
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
export const CheckBoxGroupFormItem = (props: GroupCheckBoxFormItemParameter) => {
    const {
        label,
        name,
        required,
        externalErrorMessage,
        disabled,
        options = [],
    } = props;
    const {
        control,
        register,
        setValue,
        getValues,
        clearErrors,
        resetField,
        watch,
        formState: { touchedFields, isSubmitted, errors },
    } = useFormContext();
    useEffect(() => {
        register(name)
    }, [name])

    const errorMessage = FormErrors.errorMessage(
        name,
        errors,
        touchedFields,
        isSubmitted,
        externalErrorMessage,
    );

    const [valueAll, setValueAll] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            let fromValue = (watch(name) || []);
            let values_ = options.filter(f => f.value == event.target.defaultValue)[0];
            if (values_) {
                fromValue.push(values_.value)
                setValue(name, fromValue)
                props.onChange && props.onChange(watch(name));

            }

        } else {
            let values_ = (watch(name) || []).filter(f => f != event.target.defaultValue).map(m => m);
            setValue(name, values_)
            props.onChange && props.onChange(watch(name));

        }
        clearErrors(name);


    };

    const handleChangeAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        let values_ = options.filter(f => f.disabled != true).map(m => m.value);
        if (event.target.checked == false) {
            values_ = [];
        }
        setValueAll(event.target.checked);
        setValue(name, values_)
        clearErrors(name);
    };

    const CheckboxGroup = useCallback(() => {
        let values_ = options.filter(f => f.disabled != true).map(m => m.value);
        if (values_.length == (watch(name) || []).length) {
            setValueAll(true);
        } else {
            setValueAll(false);
        }

        return (
            <>
                {
                    options.map((m, i) => (
                        <FormControlLabel
                            key={"ChG_" + i}
                            control={
                                <Checkbox size="small" onChange={handleChange}
                                    value={m.value}
                                    checked={(watch(name) || []).filter(f => f == m.value).length > 0}
                                    disabled={m.disabled || disabled}
                                    name={name}
                                    style={{ color: Boolean(errorMessage) ? "#d32f2f" : '', }}
                                />
                            }
                            style={{ color: Boolean(errorMessage) ? "#d32f2f" : 'rgba(0, 0, 0, 0.6)', fontFamily: "Kanit", fontSize: "1em" }}
                            label={m.label}
                        />
                    ))
                }
            </>
        )
    }, [options, watch(name), disabled])
    return (
        <FormControl
            key={name}
            error={Boolean(errorMessage)}
            size={"small"}
            sx={{ width: "100%" }}
        >
            {
                label
                    ?
                    <FormLabel
                        component="legend"
                        sx={{ color: errors && errors[name] ? "red !important" : "", }}>
                        {label} <span style={{ color: '#FF0000', fontSize: '15px', marginLeft: '-4px' }}>{required === true ? " *" : ""}</span>
                    </FormLabel>
                    : null
            }

            {props.AllowCheckAll &&
                <FormControlLabel
                    style={{ color: Boolean(errorMessage) ? "#d32f2f" : 'rgba(0, 0, 0, 0.6)', fontSize: '15px', paddingLeft: '0', display: "nline-flex !important" }}
                    control={
                        <Checkbox onChange={handleChangeAll} value={"All"}
                            size="small" checked={valueAll}
                            style={{ color: Boolean(errorMessage) ? "#d32f2f" : '', }}
                            disabled={disabled} />
                    }
                    label={props.labelCheckAll || "Select All"}
                />
            }
            <FormGroup row={true}
                style={{ marginLeft: "0px" }}>
                <CheckboxGroup />
            </FormGroup>

            {errors && errors[name] ? (
                <FormHelperText sx={{ color: "red" }}>
                    {errors[name].message ? errors[name].message : "กรุณาเลือกอย่างน้อย 1 รายการ"}
                </FormHelperText>
            ) : null}

        </FormControl>
    );
}
export default CheckBoxGroupFormItem;

interface GroupCheckBoxFormItemParameter {
    name: string;
    required?: boolean;
    label?: string;
    labelFront?: string;
    externalErrorMessage?: any,
    onChange?: any;
    disabled?: boolean;
    widthLabel?: string;
    options?: any[];
    AllowCheckAll?: boolean;
    labelCheckAll?: string;
    span?: string | number,
    flex?: any,
    nCol?: any,
}
